namespace SPA {
	export namespace Realtor {

		export interface IDocumentGroup {
			id: number;
			name: string;
			exportable: boolean;
			title: string;
			content: "predefined" | "mixed" | "custom";
		}

		export class DocumentGroup extends Backbone.Collection
		{
			public constructor(attributes?: IDocumentGroup | any, options?: any)
			{
				attributes.model = DocumentModel;
				attributes.url = Wollmilch.AJAXCallbase_e.APIV1 + 'artifact/list';
				super(attributes, options);

				this.on('add', this.onCollectionAdd);
			}

			private onCollectionAdd(...args: any)
			{
				console.log(args);
			}
		}
	}
}